@let controls = data.form.controls;
@let isMainBranch = controls.name == null;

<onyx-modal
  variant="center"
  [heading]="
    isMainBranch
      ? 'labels.mainBranch'
      : `labels.${data.mode === OnyxFormMode.ADD ? 'addBranch' : 'editBranch'}`
  "
  [close$]="close$"
  (closeModal)="dialogRef.close($event)"
>
  <form [formGroup]="data.form" [onyxAutoFocus]="data.mode">
    @if (!isMainBranch && controls.name) {
      <onyx-message intent="warning">
        <p>{{ `${I18N}.asDedicatedVatId` | translate }}</p>

        <onyx-button variant="ghost" [size]="32" (click)="addContractor()">
          {{ `${I18N_FORM}.addContractor` | translate }}
        </onyx-button>
      </onyx-message>

      <onyx-text-field
        [formControl]="controls.name"
        label="labels.branchName"
      ></onyx-text-field>
    }

    @let addressesControls = controls.addresses.controls;
    <ng-container [formGroup]="controls.addresses">
      <onyx-address-input
        [formControl]="addressesControls.mainAddress"
        [label]="`labels.${isMainBranch ? 'mainAddress' : 'branchAddress'}`"
        [showApartment]="true"
        apartmentWidth="110px"
      ></onyx-address-input>

      <onyx-address-input
        [formControl]="addressesControls.correspondenceAddress"
        label="labels.correspondenceAddress"
        [showApartment]="true"
        apartmentWidth="110px"
      ></onyx-address-input>
    </ng-container>
  </form>

  <onyx-button bottomLeftOptions variant="outlined" (click)="reset()">
    {{ 'labels.clear' | translate }}
  </onyx-button>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button (click)="submit()">
      {{
        `labels.${data.mode === OnyxFormMode.ADD ? 'add' : 'save'}` | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
